<template>
    <div class="main_container">
        <div class="search-box" id="searchBox">
            <div @click="showMore" class="showMoreBtn">
                <i class="iconfont icon-you" v-bind:class="{'icon-shang': isShowMore}"></i>
                <span>{{$t('message.Search')}}</span>
            </div>
            <div v-show="isShowMore">
                <el-form :label-width="labelW" :model="ruleForm" ref="ruleForm">
                    <el-form-item :label="$t('message.KeyWord')" prop="searchCondition">
                        <el-input placeholder=" "
                                  v-model="ruleForm.searchCondition"></el-input>
                    </el-form-item>
                    <div class="button-line">
                        <el-form-item>
                            <el-tooltip :content="$t('message.Search')" class="item" effect="dark" placement="top">
                                <el-button @click="submitForm('ruleForm')" class="icon iconfont icon-sousuo"
                                           type="primary"></el-button>
                            </el-tooltip>
                            <el-tooltip :content="$t('message.Reset')" class="item" effect="dark" placement="top">
                                <el-button @click="resetForm('ruleForm')"
                                           class="icon iconfont icon-zhongzhi"></el-button>
                            </el-tooltip>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
        </div>
        <div class="table_container" v-loading="isLoading">
            <el-button-group>
                <el-tooltip :content="$t('message.Add')" class="item" effect="dark" placement="top">
                    <el-button @click="handleAdd" class="icon iconfont icon-xinzeng-wubiankuang"
                               type="primary"></el-button>
                </el-tooltip>
            </el-button-group>
            <el-table
                    :data="tableData"
                    :header-cell-style="{'background-color': '#f8f8f9', 'color': '#262626'}"
                    :height="tableHeight"
                    :max-height="tableHeight"
                    :row-key="row => row.index"
                    class="table_list table_border"
                    ref="multipleTable"
                    stripe>
                <el-table-column
                        :label="$t('message.RoleName')"
                        :min-width="100"
                        prop="RoleName">
                </el-table-column>
                <el-table-column
                        :label="$t('message.RoleEnName')"
                        :min-width="120"
                        prop="RoleEnName">
                </el-table-column>
                <el-table-column
                        :label="$t('message.RoleDescription')"
                        :min-width="250"
                        :show-overflow-tooltip="true"
                        prop="Description">
                </el-table-column>
                <el-table-column :label="$t('message.Operating')" width="110">
                    <template slot-scope="scope">
                        <el-tooltip
                                :content="$t('message.Edit')"
                                class="item"
                                effect="dark"
                                placement="top"
                        >
                            <el-button
                                    @click="handleEdit(scope.row)"
                                    class="hoverBtn iconfont icon-bianji-kong"
                            ></el-button>
                        </el-tooltip>
                        <el-tooltip
                                :content="$t('message.Assign')"
                                class="item"
                                effect="dark"
                                placement="top"
                        >
                            <el-button
                                    @click="handleAssign(scope.row)"
                                    class="hoverBtn iconfont icon-fenpei"
                            ></el-button>
                        </el-tooltip>
                        <el-tooltip
                                :content="$t('message.Delete')"
                                class="item"
                                effect="dark"
                                placement="top">
                            <el-button
                                    @click="handleDelete(scope.row.ID)"
                                    class="hoverBtn iconfont icon-shanchu-kong"
                            ></el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="Pagination">
                <el-pagination
                        :current-page="currentPage"
                        :page-sizes="[10, 20, 30, 40]"
                        :total="count"
                        @current-change="handleCurrentChange"
                        @size-change="handleSizeChange"
                        background
                        layout="total, sizes, prev, pager, next, jumper">
                </el-pagination>
            </div>
        </div>
        <el-dialog
                :title="$t('message.RoleManage')"
                :visible.sync="dialogVisible"
                class="form_dialog"
                width="500px">
            <el-form :label-width="labelW" :model="roleForm" :rules="roleFormRules" ref="roleForm">
                <el-form-item :label="$t('message.RoleName')" prop="RoleName">
                    <el-input placeholder=" "
                              v-model="roleForm.RoleName"></el-input>
                </el-form-item>
                <el-form-item :label="$t('message.RoleEnName')" prop="RoleEnName">
                    <el-input placeholder=" "
                              v-model="roleForm.RoleEnName"></el-input>
                </el-form-item>
                <el-form-item :label="$t('message.RoleDescription')" prop="Description">
                    <el-input :rows="2"
                              placeholder=" "
                              type="textarea"
                              v-model="roleForm.Description"></el-input>
                </el-form-item>
            </el-form>
            <span class="dialog-footer" slot="footer">
                <el-tooltip :content="$t('message.Cancel')" class="item" effect="dark" placement="top">
                    <el-button @click="dialogVisible = false" class="iconfont icon-guanbi-wukuang"></el-button>
                </el-tooltip>
                <el-tooltip :content="$t('message.Save')" class="item" effect="dark" placement="top">
                    <el-button @click="doRole('roleForm')" class="iconfont icon-baocun1" type="primary"></el-button>
                </el-tooltip>
            </span>
        </el-dialog>
        <el-dialog
                :title="$t('message.Assign')"
                :visible.sync="dialogAssign"
                class="form_dialog"
                width="1000px">
            <el-tabs type="card" v-model="activeName">
                <el-tab-pane :label="$t('message.UserAssign')" name="first">
                    <user-assign :RoleId="roleId" v-if="dialogAssign"></user-assign>
                </el-tab-pane>
                <el-tab-pane :label="$t('message.MenuAssign')" name="second">
                    <menu-assign :RoleId="roleId" v-if="dialogAssign"></menu-assign>
                </el-tab-pane>
            </el-tabs>
            <span class="dialog-footer" slot="footer">
                <el-tooltip :content="$t('message.Close')" class="item" effect="dark" placement="top">
                    <el-button @click="dialogAssign = false" class="iconfont icon-guanbi-wukuang"></el-button>
                </el-tooltip>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {GetRolesList, CreateUpdRoles, DelRoleById} from "../api/apiRole";
    import {removeStore, getLocal} from "../config/mUtils";
    import UserAssign from "../components/userAssign";
    import MenuAssign from "../components/menuAssign";

    export default {
        name: 'role',
        components: {MenuAssign, UserAssign},
        data() {
            return {
                labelW: 0 + 'px',
                isShowMore: false,
                activeName: 'first',
                ruleForm: {
                    searchCondition: ''
                },
                roleForm: {
                    RoleName: '',
                    RoleEnName: '',
                    Description: ''
                },
                roleFormRules: {
                    RoleName: {
                        type: "string",
                        required: true,
                        message: this.$t("message.PleaseEnter") + this.$t("message.RoleName"),
                        trigger: "blur"
                    },
                    RoleEnName: {
                        type: "string",
                        required: true,
                        message: this.$t("message.PleaseEnter") + this.$t("message.RoleEnName"),
                        trigger: "blur"
                    },
                    Description: {
                        type: "string",
                        required: true,
                        message: this.$t("message.PleaseEnter") + this.$t("message.RoleDescription"),
                        trigger: "blur"
                    }
                },
                roleId: '',
                tableHeight: 0,
                isLoading: false,
                tableData: [],
                offset: 1,
                limit: 10,
                count: 0,
                currentPage: 1,
                dialogVisible: false,
                dialogAssign: false,
            }
        },
        created() {
            this.getLanguageResourceForPage();
            this.watchHeight();
            this.initData();
            this.resetLabelWidth();
            removeStore('OCRData');
            removeStore('changedInvoiceIndexData');
        },
        mounted() {
            setTimeout(() => {
                let widowHeight = document.documentElement.clientHeight - 275;
                let h = document.getElementById('searchBox').clientHeight;
                this.tableHeight = widowHeight - h;
            }, 1);
        },
        computed: {
            canResetH() {
                return this.isShowMore;
            },
            langChange() {
                return this.$i18n.locale;
            }
        },
        watch: {
            canResetH() {
                setTimeout(() => {
                    let widowHeight = document.documentElement.clientHeight - 275;
                    let h = document.getElementById('searchBox').clientHeight;
                    this.tableHeight = widowHeight - h;
                }, 1);
            },
            langChange(val) {
                if (val) {
                    this.isShowMore = false;
                    this.resetLabelWidth();
                    setTimeout(() => {
                        let widowHeight = document.documentElement.clientHeight - 275;
                        let h = document.getElementById('searchBox').clientHeight;
                        this.tableHeight = widowHeight - h;
                    }, 1);
                }
            }
        },
        methods: {
            watchHeight() {
                setTimeout(() => {
                    const that = this;
                    window.onresize = function temp() {
                        let widowHeight = document.documentElement.clientHeight - 275;
                        let h = document.getElementById('searchBox').clientHeight;
                        that.tableHeight = widowHeight - h;
                    };
                }, 1);
            },
            resetLabelWidth() {
                if (getLocal('language') === 'zh-CN') {
                    this.labelW = 100 + 'px';
                } else {
                    this.labelW = 120 + 'px';
                }
            },
            showMore() {
                this.isShowMore = !this.isShowMore;
            },
            async initData() {
                try {
                    this.getRolesList();
                } catch (err) {
                    console.log(err);
                }
            },
            // 获取角色列表
            async getRolesList() {
                this.isLoading = true;
                this.tableData = [];
                try {
                    let data = await GetRolesList(
                        this.ruleForm.searchCondition,
                        getLocal('language'),
                        this.offset,
                        this.limit
                    );
                    if (data.error_code === '0') {
                        this.isLoading = false;
                        this.count = data.data.TotalCount;
                        this.tableData = data.data.lstRole;
                    } else {
                        this.isLoading = false;
                    }
                } catch (error) {
                    this.isLoading = false;
                    console.log(error);
                }
            },
            // 更改每页显示数据条数
            handleSizeChange(val) {
                this.limit = val;
                this.currentPage = 1;
                this.offset = 1;
                this.getRolesList();
            },
            // 更改当前页数
            handleCurrentChange(val) {
                this.currentPage = val;
                this.offset = val;
                this.getRolesList();
            },
            // 搜索
            submitForm(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this.offset = 1;
                        this.currentPage = 1;
                        this.getRolesList();
                    } else {
                        return false;
                    }
                });
            },
            // 重置
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.offset = 0;
                this.currentPage = 1;
                this.getRolesList();
            },
            // 新增
            handleAdd() {
                this.roleId = '';
                this.dialogVisible = true;
                this.roleForm = {
                    RoleName: '',
                    RoleEnName: '',
                    Description: ''
                };
                this.$nextTick(() => {
                    this.$refs['roleForm'].resetFields();
                });
            },
            // 编辑
            handleEdit(row) {
                this.roleId = row.ID;
                this.dialogVisible = true;
                this.$nextTick(() => {
                    this.$refs['roleForm'].resetFields();
                    this.roleForm = {
                        RoleName: row.RoleName,
                        RoleEnName: row.RoleEnName,
                        Description: row.Description,
                    };
                });
            },
            // 新增、编辑角色
            async createUpdRoles() {
                try {
                    let data = await CreateUpdRoles(
                        this.roleId,
                        this.roleForm.RoleName,
                        this.roleForm.RoleEnName,
                        this.roleForm.Description
                    );
                    if (data.error_code === '0') {
                        this.$message.success(this.$t('message.SaveSuccessful'));
                        this.dialogVisible = false;
                        this.offset = 1;
                        this.currentPage = 1;
                        this.getRolesList();
                    } else {
                        this.$message.error(this.$t('message.SaveFailed'));
                    }
                } catch (error) {
                    console.log(error);
                }
            },
            //保存
            doRole() {
                this.$refs['roleForm'].validate((valid) => {
                    if (valid) {
                        this.createUpdRoles();
                    }
                });
            },
            //分配
            handleAssign(row) {
                this.roleId = row.ID;
                this.dialogAssign = true;
            },
            //删除角色
            async delRole(Id) {
                try {
                    let data = await DelRoleById(
                        Id,
                        getLocal('language')
                    );
                    if (data.error_code === '0') {
                        this.$message.success(this.$t('message.DeleteSuccessful'));
                        this.offset = 1;
                        this.currentPage = 1;
                        this.getRolesList();
                    } else {
                        this.$message.error(this.$t('message.DeleteFailed'));
                    }
                } catch (error) {
                    console.log(error);
                }
            },
            //删除
            handleDelete(Id) {
                this.delRole(Id);
            }
        }
    }
</script>

<style scoped>

</style>
